module.exports = require('next-server/dynamic');